import { verify_member_no } from '@/api';
import localePath from '@/utils/localePath';
export default {
  name: "verify-email",

  data() {
    return {
      form: {
        memberno: ""
      },
      rules: {
        memberno: [{
          required: true,
          message: this.$t("Invalid member no."),
          trigger: "blur"
        }]
      }
    };
  },

  methods: {
    submitForm(form) {
      this.$refs[form].validate(async valid => {
        if (valid) {
          let {
            data
          } = await verify_member_no(this.form.memberno);

          if (data.message == "OK") {
            this.$router.push(localePath({
              name: "two-step-authenication-two",
              params: {
                type: 3,
                member_no: this.form.memberno
              }
            }));
          } else {
            this.$message.error(data.message);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }

  }
};